export const cases = [
  {
    id: 1,
    company: '华远科技集团',
    industry: '智慧城市科技',
    service: '全球市场拓展',
    description: '协助华远科技成功进入东南亚六个国家的智慧城市市场，完成本地合作伙伴网络搭建，首年实现海外营收突破5000万美元。',
    imageQuery: 'Smart city technology infrastructure with modern buildings and digital connections in Southeast Asian city warm golden hour lighting',
  },
  {
    id: 2,
    company: '瑞丰新能源',
    industry: '新能源',
    service: '跨境业务合作',
    description: '帮助瑞丰新能源对接中东地区顶级能源企业，促成战略合作协议签署，项目总投资额达12亿美元，成功打开中东新能源市场。',
    imageQuery: 'Solar panel farm in desert landscape with modern energy infrastructure warm sunset lighting professional photography',
  },
  {
    id: 3,
    company: '雅生活消费品',
    industry: '消费品',
    service: '品牌国际化',
    description: '为雅生活制定全面的品牌国际化策略，完成海外品牌VI升级和多语言传播体系搭建，品牌在海外市场认知度提升300%。',
    imageQuery: 'Premium consumer product display in international retail setting with elegant branding elements warm sophisticated lighting',
  },
  {
    id: 4,
    company: '创联数字科技',
    industry: '数字科技',
    service: '数字全球化',
    description: '为创联数字搭建跨境电商全渠道运营体系，覆盖亚马逊、Shopee、Lazada等主流平台，年GMV突破8000万美元。',
    imageQuery: 'Digital commerce dashboard with multiple platform metrics on screens modern tech office setting warm professional lighting',
  },
];

export const partners = [
  { name: '中国国际贸易促进委员会', logoQuery: 'CCPIT Chinese trade promotion logo modern clean design' },
  { name: '世界华商大会', logoQuery: 'World Chinese Entrepreneurs Convention logo modern professional' },
  { name: '亚洲开发银行', logoQuery: 'Asian Development Bank logo modern professional design clean' },
  { name: '中国-东盟商务理事会', logoQuery: 'China ASEAN Business Council logo modern corporate design' },
  { name: '国际商会', logoQuery: 'International Chamber of Commerce logo modern professional clean' },
  { name: '一带一路发展中心', logoQuery: 'Belt and Road development center logo modern Chinese design' },
];

export const stats = [
  { value: '500+', label: '服务企业', icon: 'ri-building-line' },
  { value: '50+', label: '覆盖国家', icon: 'ri-earth-line' },
  { value: '10年+', label: '行业经验', icon: 'ri-time-line' },
  { value: '98%', label: '客户满意度', icon: 'ri-heart-line' },
];